import { jsx as o, Fragment as j, jsxs as g } from "react/jsx-runtime";
import { useState as z } from "react";
import F from "@mui/material/Tooltip";
import t from "@mui/material/Box";
import O from "@mui/material/Fade";
import D from "@mui/material/Stack";
import { T as h } from "./Typography-HkIo7ajX.js";
import "@mui/material";
import { s as n } from "./spacings-C27fg6SF.js";
const v = -6, P = 9999999, X = ({
  children: a,
  titleIcon: p = null,
  title: r = "",
  text: e = "",
  topExtraContent: l = null,
  extraContent: i = null,
  placement: x = "top",
  isOpen: y = !1,
  minBodyWidth: T = void 0,
  maxBodyWidth: b = void 0,
  onOpen: m = void 0,
  onClose: f = void 0,
  hasArrow: d = !0,
  shouldHighlightChildIcon: B = !0,
  zIndex: I = P,
  shouldDisableInteractive: W = !1
}) => {
  const [c, u] = z(!1);
  return !e && !r ? /* @__PURE__ */ o(j, { children: a }) : /* @__PURE__ */ o(
    F,
    {
      TransitionComponent: O,
      disableInteractive: W,
      title: /* @__PURE__ */ g(t, { children: [
        !!l && l,
        !!r && /* @__PURE__ */ g(
          D,
          {
            ...e && { mb: n.xs },
            direction: "row",
            alignItems: "center",
            gap: n.xs,
            children: [
              !!p && p,
              /* @__PURE__ */ o(
                h,
                {
                  variant: "text",
                  size: "xs",
                  fontWeight: "semibold",
                  children: r
                }
              )
            ]
          }
        ),
        !!e && /* @__PURE__ */ o(t, { ...i && { mb: n.xs }, children: /* @__PURE__ */ o(
          h,
          {
            variant: "text",
            size: "xs",
            color: "grey.300",
            fontWeight: "medium",
            children: e
          }
        ) }),
        !!i && i
      ] }),
      placement: x,
      arrow: d,
      PopperProps: {
        sx: {
          zIndex: `${I} !important`,
          minWidth: T ?? "max-content",
          maxWidth: b
        },
        popperOptions: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, d ? v : v * 2]
              }
            }
          ]
        }
      },
      role: "tooltip",
      "aria-label": r || e,
      open: y || c,
      onOpen: () => {
        m ? m() : u(!0);
      },
      onClose: () => {
        f ? f() : u(!1);
      },
      children: /* @__PURE__ */ o(
        t,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...B && {
              "&:hover": {
                cursor: "pointer",
                "& svg": (s) => ({
                  color: s.palette.primary[700]
                })
              },
              ...c && {
                "& svg": (s) => ({
                  color: s.palette.primary[700]
                })
              }
            }
          },
          children: a
        }
      )
    }
  );
};
export {
  X as T
};
